import { useSectorMark } from '@hooks/useSectorMarkHook';
import { numFormat } from '@utils/tool';

export const editIcon = (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 6.4V8H3.6L10 1.6V1.06667L8.93333 0H8.4L2 6.4Z" fill="#C2CDD6" />
    <path d="M0 11H12V10H0V11Z" fill="#C2CDD6" />
  </svg>
);

export const use_ANNOUNCEMENTINFORMATION = () => {
  const sectorMark = useSectorMark();
  return [
    // { label: '信息标题', value: '', key: 'infoTitle' },

    { label: '客户单位', value: '', key: 'customerCompany' },
    { label: '客户单位联系人', value: '', key: 'tenderOrgContacts' },
    { label: '客户单位联系方式', value: '', key: 'tenderOrgContactsMobile' },
    {
      label: sectorMark,
      value: '',
      key: 'sectorTypeValue'
    },

    {
      label: '客户单位类型',
      value: '',
      key: 'customerCompanyTypeName',
      render: (record: any) => {
        return record.customerCompanyTypeName
          ? `${record.customerCompanyTypeName}${
              record.customerCompanySecondTypeName ? '/' : ''
            } ${record.customerCompanySecondTypeName || ''}`
          : '';
      }
    },
    { label: '行业', value: '', key: 'industryName' },
    {
      label: '应用方向',
      value: '',
      key: 'applicationDirectionName',
      render: (record: any) => {
        return record.applicationDirectionName
          ? `${record.applicationDirectionName}${
              record.applicationDirectionSecondName ? '/' : ''
            } ${record.applicationDirectionSecondName || ''}`
          : '';
      }
    },
    {
      label: '招标预算（万元）',
      value: '',
      key: 'tenderBudget',
      montage: 'tenderBudgetCurrency',
      render: (record: any) => {
        return record.tenderBudget
          ? numFormat(record.tenderBudget) +
              ' ' +
              (record.tenderBudgetCurrencyValue || '')
          : '';
      }
    },
    // { label: '预计采购时间', value: '', key: 'estimatedPurchaseTime' },
    { label: '发布时间', value: '', key: 'publishTime' },
    { label: '开标时间', value: '', key: 'tenderOpenTime' },
    { label: '招标机构', value: '', key: 'tenderDealer' },
    {
      label: '整包中标金额（万元）',
      value: '',
      key: 'successfulPrice',
      render: (record: any) => {
        return record.successfulPrice
          ? numFormat(record.successfulPrice) +
              ' ' +
              (record.successfulPriceCurrencyValue || '')
          : '';
      }
    },
    {
      label: '整包中标金额备注',
      value: '',
      key: 'successfulPriceRemark',
      montage: 'successfulPriceCurrencyValue',
      needConversion: true
    },
    { label: '省市', value: '', key: 'provinceName', montage: 'cityName' }
  ];
};

export const CURRENCY = ['CNY', 'USD', 'EUR'];
